import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import FooterLinkItemCMSModel from '@/visa-application/models/FooterLinkItemCMSModel';

export interface SocialMedia {
  logo: string;
  link: string;
}

export default class FooterLinkCMSModel implements CMSModel {
  public linkedin_url = '';
  public facebook_url = '';
  public ndpr_logo = false;
  public socialMedia: SocialMedia[] = [];
  public linksItems: FooterLinkItemCMSModel = new FooterLinkItemCMSModel();

  map(obj: any): void {
    this.linkedin_url = _.get(obj, 'linkedin_url', '');
    this.facebook_url = _.get(obj, 'facebook_url', '');
    this.ndpr_logo = _.get(obj, 'ndpr_logo', false);
    this.linksItems = _.get(obj, 'translation[0].links_items', new FooterLinkItemCMSModel());
    this.socialMedia = _.get(obj, 'socialmedia', []);
  }
}
